import { useClickAway } from "@uidotdev/usehooks";
import { LucideIcon } from "lucide-react";
import * as React from "react";
import styled from "styled-components";

interface Props {
  active?: boolean;
  label: string;
  icon: LucideIcon;
  "data-testid"?: string;
  onClick?(): void;
}

export function TaskFormPill({
  active = false,
  label,
  icon: Icon,
  "data-testid": testId,
  onClick,
}: Props) {
  const [open, setOpen] = React.useState(false);
  const ref = useClickAway<HTMLButtonElement>(() => {
    setOpen(false);
  });

  const handleClick = onClick ?? (() => setOpen(!open));

  return (
    <Container type="button" ref={ref} $active={active} onClick={handleClick} data-testid={testId}>
      <Icon size={12} />
      <Label>{label}</Label>
    </Container>
  );
}

const Container = styled.button<{ $active: boolean }>`
  background: var(--box-color);
  border: 1px solid var(--box-border-color);
  padding: 3px 8px;
  border-radius: 5px;
  font-size: 14px;
  display: flex;
  gap: 6px;
  align-items: center;
  ${({ $active }) =>
    $active &&
    `
    background-color: var(--theme-color-primary);
    border-color: var(--theme-color-light);
  `}
`;

const Label = styled.div`
  padding-right: 2px;
`;
